(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bokja-category-groups"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-cardnav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var media = btn.closest('[data-bokja-gallery]');
    if (!media) return;
    var imgs = media.querySelectorAll('img[data-idx]');
    if (imgs.length < 2) return;
    var cur = media.querySelector('img.is-current') || imgs[0];
    var idx = parseInt(cur.getAttribute('data-idx') || '0', 10);
    var next = (idx + parseInt(btn.getAttribute('data-bokja-cardnav'), 10) + imgs.length) % imgs.length;
    cur.classList.remove('is-current');
    imgs[next].classList.add('is-current');
    var item = btn.closest('.bokja-catgroup__item, .bokja-storygroup__item');
    if (item) item.setAttribute('data-nav', '1');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-category-nav"] && !Shopify.designMode) return;
  try {
    
  /* ---- quiet cushion filters (James 2026-08-06) ---- */
  (function () {
    var bar = document.querySelector('[data-bokja-cfilters]');
    var flat = document.querySelector('[data-bokja-filtered]');
    // The engine lives HERE (moved from bokja-story-groups, 2026-08-24) because the
    // compiled bundle gates each section's javascript on the section being present on
    // the page - and this nav is the one section every filtered template renders:
    // cushions (story groups) and the All Homeware / All Ready to Wear landings
    // (category groups). Same cards contract (data-f-*), two wrapper vocabularies.
    // Wakes only where the panel above actually rendered (setting cushion_filters).
    var wrap = document.querySelector('.bokja-storygroups, .bokja-catgroups');
    if (!bar || !flat || !wrap || bar.__bokjaInit) return;
    bar.__bokjaInit = true;

    /* Dropdown chrome (2026-08-24): the bar became a panel behind a trigger at the end
       of the category row (markup in bokja-category-nav). The engine below is untouched
       in what it queries; this block only opens/closes the panel and echoes the active
       picks into the trigger. */
    var toggle = document.querySelector('[data-bokja-cfilters-toggle]');
    var summary = toggle ? toggle.querySelector('[data-bokja-cfilters-summary]') : null;
    var idleLabel = summary ? summary.textContent : '';

    function setOpen(open) {
      if (!toggle) return;
      bar.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.classList.toggle('is-open', open);
    }

    function updateSummary() {
      if (!summary) return;
      var act = bar.querySelectorAll('.bokja-cfilters__dot.is-active, .bokja-cfilters__opt.is-active:not([data-f-all])');
      summary.textContent = '';
      toggle.classList.toggle('is-active', act.length > 0);
      if (!act.length) { summary.textContent = idleLabel; return; }
      Array.prototype.forEach.call(act, function (b, i) {
        if (i) summary.appendChild(document.createTextNode(' · '));
        if (b.hasAttribute('data-f-colour')) {
          var d = document.createElement('span');
          d.className = b.className.replace(/\bis-active\b/, '').trim() + ' bokja-cfilters__dot--mini';
          summary.appendChild(d);
        } else {
          summary.appendChild(document.createTextNode(b.textContent.trim()));
        }
      });
    }

    if (toggle) {
      // The trail is sticky: while inertial scroll settles, the row slides out from
      // under a STILL finger between press and release and the browser cancels the
      // click - the same quirk James click-rescued for the trail links (2026-08-06),
      // and the likely reason taps on the old inline bar read as dead on a real
      // iPhone (Malou 2026-08-24). The trigger therefore acts on pointerup with a
      // movement guard; click is neutered except as the keyboard path.
      var pd = null;
      toggle.addEventListener('pointerdown', function (e) { pd = { x: e.clientX, y: e.clientY }; });
      toggle.addEventListener('pointerup', function (e) {
        if (!pd) return;
        var d = pd; pd = null;
        if (Math.abs(e.clientX - d.x) > 12 || Math.abs(e.clientY - d.y) > 12) return;
        setOpen(bar.hidden);
      });
      toggle.addEventListener('click', function (e) { e.preventDefault(); });
      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(bar.hidden); }
      });
      document.addEventListener('pointerdown', function (e) {
        if (bar.hidden) return;
        if (bar.contains(e.target) || toggle.contains(e.target)) return;
        setOpen(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !bar.hidden) { setOpen(false); toggle.focus(); }
      });
    }

    var cards = Array.prototype.slice.call(wrap.querySelectorAll('.bokja-storygroup__item, .bokja-catgroup__item'));
    var state = { colour: null, material: null, size: null };

    // Reveal only the options that match at least one cushion; build the size row.
    var have = { colour: {}, material: {}, size: {} };
    cards.forEach(function (c) {
      (c.getAttribute('data-f-colours') || '').split(' ').forEach(function (v) { if (v) have.colour[v] = 1; });
      (c.getAttribute('data-f-material') || '').split(' ').forEach(function (v) { if (v) have.material[v] = 1; });
      var s = c.getAttribute('data-f-size');
      if (s) have.size[s] = 1;
    });
    bar.querySelectorAll('[data-f-colour]').forEach(function (b) { if (have.colour[b.getAttribute('data-f-colour')]) b.hidden = false; });
    bar.querySelectorAll('[data-f-material]').forEach(function (b) { if (have.material[b.getAttribute('data-f-material')]) b.hidden = false; });
    // Sizes bucket into three quiet words by the cushion's longest side
    // (raw dimensions would be 15 buttons incl. orientation duplicates).
    function bucket(s) {
      if (!s) return null;
      var m = Math.max.apply(null, s.split('X').map(Number));
      return m <= 46 ? 'small' : m <= 61 ? 'medium' : 'large';
    }
    var haveBuckets = {};
    Object.keys(have.size).forEach(function (s) { haveBuckets[bucket(s)] = 1; });
    // Size is a CUSHION axis and stays on the cushions page only (Malou 2026-08-25):
    // on the All Homeware landing the buckets came solely from the cushions mixed in,
    // so picking one silently hid every quilt, sofa and tapestry. The cushions page
    // is the storygroups wrap; the catgroups landings never reveal the row (it hides
    // itself whole via the :has rule when no button is shown).
    if (wrap.classList.contains('bokja-storygroups')) {
      bar.querySelectorAll('[data-f-size]').forEach(function (b) { if (haveBuckets[b.getAttribute('data-f-size')]) b.hidden = false; });
    }

    function spans(n) {
      var kids = Array.prototype.slice.call(flat.children);
      kids.forEach(function (k) { k.classList.remove('f-span4', 'f-span6', 'f-span12'); });
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      if (mobile) {
        if (n === 1) kids[0].classList.add('f-span12');
        else if (n % 2 === 1) kids.slice(-3).forEach(function (k) { k.classList.add('f-span4'); });
      } else {
        // Desktop: cards never wider than a quarter of the line (James 2026-08-06:
        // "minimum three" - a 2-up remainder row reads gigantic). Remainders resolve
        // as rows of three (span 4); below 3 results the row stays honest-but-short.
        var r = n % 4;
        if (n <= 3) kids.forEach(function (k) { k.classList.add('f-span4'); });
        else if (r === 3) kids.slice(-3).forEach(function (k) { k.classList.add('f-span4'); });
        else if (r === 2) {
          if (n >= 6) kids.slice(-6).forEach(function (k) { k.classList.add('f-span4'); });
          else kids.slice(-2).forEach(function (k) { k.classList.add('f-span4'); });
        } else if (r === 1) {
          if (n >= 9) kids.slice(-9).forEach(function (k) { k.classList.add('f-span4'); });
          else kids.slice(-5).forEach(function (k) { k.classList.add('f-span4'); });
        }
      }
    }

    function countFor(st) {
      return cards.filter(function (c) {
        if (st.colour && (' ' + (c.getAttribute('data-f-colours') || '') + ' ').indexOf(' ' + st.colour + ' ') === -1) return false;
        if (st.material && (' ' + (c.getAttribute('data-f-material') || '') + ' ').indexOf(' ' + st.material + ' ') === -1) return false;
        if (st.size && bucket(c.getAttribute('data-f-size')) !== st.size) return false;
        return true;
      }).length;
    }

    function muteDeadEnds() {
      ['colour', 'material', 'size'].forEach(function (axis) {
        bar.querySelectorAll('[data-f-' + axis + ']').forEach(function (b) {
          if (b.hidden) return;
          var probe = { colour: state.colour, material: state.material, size: state.size };
          probe[axis] = b.getAttribute('data-f-' + axis);
          b.classList.toggle('is-muted', countFor(probe) === 0 && !b.classList.contains('is-active'));
        });
      });
    }

    function apply() {
      var active = state.colour || state.material || state.size;
      bar.querySelectorAll('[data-f-colour]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-f-colour') === state.colour); });
      bar.querySelectorAll('[data-f-material]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-f-material') === state.material); });
      bar.querySelectorAll('[data-f-size]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-f-size') === state.size); });
      bar.querySelector('[data-f-all]').classList.toggle('is-active', !active);
      var groups = wrap.querySelectorAll('.bokja-storygroup, .bokja-catgroup');
      if (!active) {
        flat.hidden = true;
        flat.innerHTML = '';
        groups.forEach(function (g) { g.hidden = false; });
        return;
      }
      var matches = cards.filter(function (c) {
        if (state.colour && (' ' + (c.getAttribute('data-f-colours') || '') + ' ').indexOf(' ' + state.colour + ' ') === -1) return false;
        if (state.material && (' ' + (c.getAttribute('data-f-material') || '') + ' ').indexOf(' ' + state.material + ' ') === -1) return false;
        if (state.size && bucket(c.getAttribute('data-f-size')) !== state.size) return false;
        return true;
      });
      flat.innerHTML = '';
      if (!matches.length) {
        var empty = document.createElement('p');
        empty.className = 'bokja-cfilters__empty';
        empty.textContent = flat.getAttribute('data-empty-text') || 'Nothing matches this combination';
        flat.appendChild(empty);
      } else {
        matches.forEach(function (c) { flat.appendChild(c.cloneNode(true)); });
      }
      groups.forEach(function (g) { g.hidden = true; });
      flat.hidden = false;
      if (matches.length) spans(matches.length);
    }

    bar.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-f-all')) { state = { colour: null, material: null, size: null }; }
      else if (b.hasAttribute('data-f-colour')) { var v = b.getAttribute('data-f-colour'); state.colour = state.colour === v ? null : v; }
      else if (b.hasAttribute('data-f-material')) { var m = b.getAttribute('data-f-material'); state.material = state.material === m ? null : m; }
      else if (b.hasAttribute('data-f-size')) { var s = b.getAttribute('data-f-size'); state.size = state.size === s ? null : s; }
      apply();
      muteDeadEnds();
      updateSummary();
      if (toggle) {
        setOpen(false);
        // The swap happens at the top of the page; from further down it used to read
        // as nothing happening. Bring the results under the trail (scroll-margin-top
        // on the grid clears the pinned header). Clearing back to All stays put.
        if (state.colour || state.material || state.size) {
          requestAnimationFrame(function () { flat.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        }
      }
    });
    muteDeadEnds();
    window.addEventListener('resize', function () { if (!flat.hidden && flat.children.length) spans(flat.children.length); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-gallery"]) return;
  try {
    
  /* Drawer image track: the arrows scroll one slide, the counter follows the scroll position.
     Delegated from the document and bound once, so re-rendered sections never double-bind. */
  (function () {
    if (window.__bokjaGalleryTrack) return;
    window.__bokjaGalleryTrack = true;

    function slideWidth(track) {
      var slide = track.querySelector('.bokja-gal-drawer__slide');
      var w = slide ? slide.getBoundingClientRect().width : track.clientWidth;
      return w || track.clientWidth;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var button = event.target.closest('[data-gal-prev], [data-gal-next]');
      if (!button) return;
      var viewer = button.closest('.bokja-gal-drawer__viewer');
      var track = viewer && viewer.querySelector('[data-gal-track]');
      if (!track) return;
      var forward = button.hasAttribute('data-gal-next');
      /* RTL scrollLeft runs negative, so step with the writing direction, not with x. */
      var rtl = getComputedStyle(track).direction === 'rtl';
      var step = slideWidth(track) * (forward ? 1 : -1) * (rtl ? -1 : 1);
      track.scrollBy({ left: step, behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      function (event) {
        var track = event.target;
        if (!track || !track.hasAttribute || !track.hasAttribute('data-gal-track')) return;
        var w = slideWidth(track);
        if (!w) return;
        var index = Math.round(Math.abs(track.scrollLeft) / w) + 1;
        var out = track.parentElement && track.parentElement.querySelector('[data-gal-current]');
        if (out && out.textContent !== String(index)) out.textContent = String(index);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-home-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vids = document.querySelectorAll('[data-bokja-vhero] video');
    for (var i = 0; i < vids.length; i++) {
      (function (v) {
        // Reduced motion: leave the poster standing, never play the loop.
        if (reduce) { try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {} return; }
        // Breakpoint-hidden twin (desktop/mobile source switch): don't load or play it.
        if (v.offsetParent === null) { try { v.preload = 'none'; v.removeAttribute('autoplay'); v.pause(); } catch (e) {} return; }
        // Reveal the video (over the poster) only once it is genuinely playing — so a slow,
        // blocked or failed video never blanks the hero; the poster just stays.
        // Reveal the video over the poster ONLY on genuine playback. canplay / readyState>=3 are
        // buffering states that also fire when muted-autoplay is blocked or stalls, which would
        // reveal a frozen frame over the poster (the fail-closed mode the design avoids). (audit T13)
        var poster = v.parentNode && v.parentNode.querySelector('.bokja-vhero__poster');
        var reveal = function () {
          v.classList.add('is-playing');
          // The video is now the visual, so hide the duplicate poster from assistive tech. The poster
          // is exposed by default (no static aria-hidden); when the video never plays (no video,
          // reduced motion, blocked autoplay) it stays the accessible hero image. (audit T14)
          if (poster) poster.setAttribute('aria-hidden', 'true');
        };
        v.addEventListener('playing', reveal);
        // Catch a video already playing before this listener attached (fast-load race).
        if (!v.paused && !v.ended && v.currentTime > 0) reveal();
      })(vids[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-jw-grid"] && !Shopify.designMode) return;
  try {
    
  /* Keep the comparison self-contained: while viewing ?view=jw, collection links
     (the category strip, footer shortcuts) carry the view param along so browsing
     categories stays inside the mock. Runs only on pages using this section. */
  (function () {
    if (!/[?&]view=jw(&|$)/.test(window.location.search)) return;
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      try {
        var url = new URL(links[i].href, window.location.origin);
        if (url.origin !== window.location.origin) continue;
        if (url.pathname.indexOf('/collections/') === -1) continue;
        url.searchParams.set('view', 'jw');
        links[i].href = url.pathname + url.search + url.hash;
      } catch (e) {
        /* leave the link untouched */
      }
    }
  })();

  /* Fabric swab: hovering a tile fills the fixed end-edge strip with a macro of
     the image that tile is currently presenting. Mirrors the card's own display
     logic (arrow/swipe flips win, otherwise the hover preview side) instead of
     reading mid-transition opacities. */
  (function () {
    var strip = document.querySelector('[data-bokja-jw-swatch]');
    if (!strip) return;
    var stripImg = strip.querySelector('.bokja-jw-swatch__image');

    function presentedImage(item) {
      var card = item.querySelector('.bokja-product-placeholder-card');
      if (!card) return null;
      if (card.classList.contains('bokja-carousel-active')) {
        var flipped = card.querySelector('.bokja-product-placeholder-card__image.is-active');
        if (flipped) return flipped;
      }
      var side = document.documentElement.getAttribute('data-bokja-shop-side');
      var hoverShows = side === 'ready_to_wear' ? '--homeware' : '--ready';
      return card.querySelector('.bokja-product-placeholder-card__image' + hoverShows);
    }

    document.addEventListener('pointerover', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var item = event.target.closest && event.target.closest('.bokja-jw-item');
      if (!item) return;
      var source = presentedImage(item);
      if (!source) return;
      var src = source.currentSrc || source.src;
      if (src && stripImg.getAttribute('src') !== src) stripImg.src = src;
      strip.classList.add('is-open');
    });

    document.addEventListener('pointerout', function (event) {
      var item = event.target.closest && event.target.closest('.bokja-jw-item');
      if (!item) return;
      var to = event.relatedTarget;
      if (to && to.closest && to.closest('.bokja-jw-item')) return;
      strip.classList.remove('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-stockists"] && !Shopify.designMode) return;
  try {
    
  // Stockist category filter. Progressive enhancement in both directions: the control ships
  // `hidden` and is revealed only when the data exists, and with JS off nothing is ever
  // hidden, so the page degrades to the full 45-entry list it is today.
  (function () {
    var VALUES = ['homeware', 'ready-to-wear'];
    var PARAM = 'carries';
    var current = '';

    function carriesOf(el) {
      var raw = el.getAttribute('data-carries') || '';
      return raw.split(' ').filter(function (v) { return v; });
    }

    // Reflect the view in the URL so a filtered list is linkable (an email can point at the
    // homeware stockists). replaceState, not pushState: the back button belongs to the page
    // the shopper arrived from, not to three filter clicks.
    function syncUrl(value) {
      if (!window.history || !history.replaceState || !window.URL) return;
      try {
        var u = new URL(window.location.href);
        if (value) u.searchParams.set(PARAM, value);
        else u.searchParams.delete(PARAM);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    function apply(value, updateUrl) {
      current = VALUES.indexOf(value) === -1 ? '' : value;

      var items = document.querySelectorAll('.bokja-stockists__item');
      var withheld = 0;
      var i, el, cats, show;

      for (i = 0; i < items.length; i++) {
        el = items[i];
        cats = carriesOf(el);
        if (!current) {
          show = true;                              // All: every stockist, always
        } else if (!cats.length) {
          show = false;                             // uncategorised is withheld, and counted
          withheld++;
        } else {
          show = cats.indexOf(current) !== -1;
        }
        if (show) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }

      // A region whose every entry is hidden takes its heading and its padding with it,
      // otherwise a filter leaves "Australia" standing over nothing.
      var regions = document.querySelectorAll('.bokja-stockists__region');
      for (i = 0; i < regions.length; i++) {
        if (regions[i].querySelector('.bokja-stockists__item:not([hidden])')) {
          regions[i].removeAttribute('hidden');
        } else {
          regions[i].setAttribute('hidden', '');
        }
      }

      var buttons = document.querySelectorAll('[data-carries-filter]');
      for (i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute(
          'aria-pressed',
          (buttons[i].getAttribute('data-carries-filter') || '') === current ? 'true' : 'false'
        );
      }

      // Say what is being withheld rather than presenting a part-filled list as the answer.
      var note = document.querySelector('[data-bokja-stockist-note]');
      if (note) {
        var tpl = note.getAttribute('data-note-template') || '';
        if (withheld > 0 && tpl) {
          note.textContent = tpl.replace('[n]', String(withheld));
          note.removeAttribute('hidden');
        } else {
          note.setAttribute('hidden', '');
        }
      }

      if (updateUrl) syncUrl(current);
    }

    function init() {
      var bar = document.querySelector('[data-bokja-stockist-filter]');
      if (!bar) return;

      // The reveal test: does ANY stockist carry a category yet? Until one does, the control
      // would be three switches that all return the same 45 names.
      var items = document.querySelectorAll('.bokja-stockists__item');
      var live = false;
      for (var i = 0; i < items.length; i++) {
        if (carriesOf(items[i]).length) { live = true; break; }
      }
      if (!live) {
        bar.setAttribute('hidden', '');
        apply('', false);                            // clear any stale hidden state
        return;
      }
      bar.removeAttribute('hidden');

      var start = '';
      try {
        start = new URL(window.location.href).searchParams.get(PARAM) || '';
      } catch (e) {}
      apply(start, false);                           // deep link honoured, URL left as found
    }

    // Delegated, so it survives the theme editor re-rendering a section under it.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-carries-filter]');
      if (!btn) return;
      e.preventDefault();
      apply(btn.getAttribute('data-carries-filter') || '', true);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bokja-story-groups"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-cardnav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var media = btn.closest('[data-bokja-gallery]');
    if (!media) return;
    var imgs = media.querySelectorAll('img[data-idx]');
    if (imgs.length < 2) return;
    var cur = media.querySelector('img.is-current') || imgs[0];
    var idx = parseInt(cur.getAttribute('data-idx') || '0', 10);
    var next = (idx + parseInt(btn.getAttribute('data-bokja-cardnav'), 10) + imgs.length) % imgs.length;
    cur.classList.remove('is-current');
    imgs[next].classList.add('is-current');
    var item = btn.closest('.bokja-catgroup__item, .bokja-storygroup__item');
    if (item) item.setAttribute('data-nav', '1');
  });

  /* ---- quiet cushion filters: ENGINE MOVED (2026-08-24, same day as the dropdown) ----
     The filter engine now lives in bokja-category-nav's javascript tag. The compiled
     bundle GATES each section's javascript on that section being present on the page
     (__sections__ check in compiled_assets/scripts.js) - so from here it never ran on
     the All Homeware / All Ready to Wear landings, which render bokja-category-groups,
     not this section. The nav is on every filtered template AND owns the trigger and
     panel, so the engine rides with it. The results-grid styles stay in this
     stylesheet; the cards contract (data-f-* attributes) is unchanged. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
